// extracted by mini-css-extract-plugin
export default {"innerWrapper":"nz-z","tooltipWrapper":"oz-z","icon":"pz-z","tooltip":"qz-z","content":"rz-z"};